import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { UiSortMenu } from '@/components';
import type { SortMenuItem } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraProcessingCostsSort',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { t } = useI18n();

const items = ref<SortMenuItem[]>([
    { label: t('aura.processingCosts.sort.startedAt'), key: 'startedAt' },
    { label: t('aura.processingCosts.sort.costUsd'), key: 'costUsd' },
    { label: t('aura.processingCosts.sort.tokensUsed'), key: 'tokensUsed' },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UiSortMenu), {
    items: items.value,
    "model-value": props.modelValue,
    fixmobile: "",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
  }, null, 8, ["items", "model-value"]))
}
}

})